import React from "react";
import { useAuth } from "@/lib/auth";
import IndividualDashboard from "./IndividualDashboard";
import BusinessDashboard from "./BusinessDashboard";
import NeutralDashboard from "./NeutralDashboard";
import AdminDashboard from "./AdminDashboard";

export default function DashboardRouter() {
  const { user } = useAuth();
  if (user.role === "individual") return <IndividualDashboard />;
  if (user.role === "business") return <BusinessDashboard />;
  if (user.role === "neutral") return <NeutralDashboard />;
  if (user.role === "admin") return <AdminDashboard />;
  return null;
}
